import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import useFeedback from "../../utils/use_feedback";
import {useProfile} from "../../api/user";
import {useRelativeTime} from "../../store";
import {Header, Title} from './sheet';

const Item = styled.div``;
const ItemName = styled.div``;
const ItemValue = styled.div``;

const UserDetailsSheet = styled(({className, username, onClose}) => {

    const {error, feedbackCh} = useFeedback();
    const profile = useProfile(feedbackCh, username);

    const age = useRelativeTime(profile?.created, false);

    return (
        <div className={className}>
            <Header>
                <Title>
                    About
                </Title>
            </Header>

            {profile &&
                <div>
                    <Item>
                        <ItemName>
                            Comment Score
                        </ItemName>
                        <ItemValue>
                            {profile.comment_score}
                        </ItemValue>
                    </Item>
                    <Item>
                        <ItemName>
                            Post Score
                        </ItemName>
                        <ItemValue>
                            {profile.post_score}
                        </ItemValue>
                    </Item>
                    <Item>
                        <ItemName>
                            Joined
                        </ItemName>
                        <ItemValue>
                            {age} ago
                        </ItemValue>
                    </Item>
                </div>
                }
        </div>
    );
})`

  ${Item} {
    margin-bottom: 16px;
  }
  
  ${Item}:last-of-type {
    margin-bottom: 0;
  }
  
  ${ItemName} {
    font-weight: 600;
    font-size: 17px;
    padding-bottom: 2px;
  }

  ${ItemValue} {
    font-size: 15px;
  }

`;

export default UserDetailsSheet;
